import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const {API_URLPG,API_URLBLAZE,adminUser} = environment;

@Injectable({
  providedIn: 'root'
})

export class PaymentGatewayService {
  private systemAdmin : any = adminUser;

    constructor(private apiHttpService: HttpClient, private storageService: StorageService, private router: Router) { }

    //*********** MERCHANT ACCOUNT LIST **************
      getBusinessTypeList() {
        return this.apiHttpService.get(`${API_URLPG}crm-merchant-setup/fetchBusinessList`);
      }
    
      getMerchantAccountList(businessType: string, email: string) {
        return this.apiHttpService.get(`${API_URLPG}crm-merchant-setup/fetchMerchantList/${businessType}/${this.systemAdmin}`);
      }


    //*********** MERCHANT ACCOUNT EDIT ******************
    
      getCountries() {
        return this.apiHttpService.get(`${API_URLPG}getCountries`);
      }
    
      getStates(countryName: string) {
        return this.apiHttpService.get(`${API_URLPG}getStates?countryName=${countryName}`);
      }

      getEditDetails(data: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/merchantEdit`, data);
      }

      getStaticEncKey(payId: any) {
        return this.apiHttpService.get(`${API_URLBLAZE}/user/merchant/getStaticKey/${payId}`);
      }
    
      getUserStatus() {
        return this.apiHttpService.get(`${API_URLPG}crm-merchant-setup/user-status-type`);
      }
    
      getModType() {
        return this.apiHttpService.get(`${API_URLPG}crm-merchant-setup/mode-type`);
      }
    
      merchantSave(data: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/merchantSetupSave`, data);
      }
    
      pennyDrop(data: any) {
        return this.apiHttpService.post(`${API_URLPG}pennyDrop`, data);
      }
    
      getAllMerchants() {
        return this.apiHttpService.get(`${API_URLPG}crm-dashboard/active-merchants`);
      }

      saveSplitPayment(data: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-split-payment/save`, data);
      }
      
      fetchSplitPayment(email: string) {
        return this.apiHttpService.get(`${API_URLPG}/crm-split-payment/fetch/${this.systemAdmin}`);
      }

      deleteSplitPayment(bankId: string, email: string) {
        return this.apiHttpService.post(`${API_URLPG}crm-split-payment/delete/${bankId}/${this.systemAdmin}`, {});
      }
    

    //************* MERCHANT MAPPING **************

      getAllAcquiers(): Observable<any> {
        return this.apiHttpService.get(`${API_URLPG}crm-dashboard/acquirer-types`);
      }

      mopSetUpCurrency(data: any): Observable<any> {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/mop-set-up`, data);
      }

      mopSetUpDisplay(data: any): Observable<any> {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/mop-set-up-display`, data);
      }

      mopSetUp(data: any): Observable<any> {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/mopSetup`, data);
      }



    //************* TDR SETTING **************

      getMappedAcquirer(emailId: string) {
        return this.apiHttpService.get(`${API_URLPG}acquirer/getMappedAcquirerForTdr?emailId=${emailId}`);
      }
      
      getCurrencyList(emailId: string, acquirer: string) {
        return this.apiHttpService.get(`${API_URLPG}TdrAndSurcharge/getCurrencyList?acquirer=${acquirer}&emailId=${emailId}`);
      }
    
      getTdrSurchargeSettingList(data: any): Observable<any> {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/tdr-surcharge-setting`, data);
      }
    
      editTdrSurchargeSetting(data: any): Observable<any> {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/edit-tdr-surcharge-setting`, data);
      }


    
    //************* RULE ENGINE **************

      deleteRules(payload: { ids: number[], loggedUserEmailId: string }): Observable<any> {
        return this.apiHttpService.delete(`${API_URLPG}crm-merchant-setup/deleteRules`, { body: payload });
      }

      deleteRule(id: number, loggedUserEmailId: string): Observable<any> {
        const url = `${API_URLPG}crm-merchant-setup/deleteRule/${id}/${this.systemAdmin}`;
        return this.apiHttpService.delete(url);
      }

      getRuleLists(merchantId: string) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/getRuleList`, {
          payId: merchantId,
          loggedUserEmailId: this.systemAdmin
        });
      }

      getAcquirer(merchantId: string) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/getData`, {
          type: 1,
          payId: merchantId,
          Acquirer1: "DEMO",
          loggedUserEmailId: this.systemAdmin
        });
      }

      fetchCurrencies(payload: { merchantId: string; acquirer: string }): Observable<any> {
        // Create the request object
        const requestPayload = {
          payId: payload.merchantId,
          Acquirer1: payload.acquirer,
          loggedUserEmailId: this.systemAdmin,
          type: 2
    
        };
        console.log("request pauload for fetching currency: ", requestPayload);
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/getData`, requestPayload);
      }
    
    
      getPaymentTypes(requestBody: { merchantId: string; currencies: string[]; acquirer: string }): Observable<any> {
    
        // Create the request object
        const requestPayload = {
          payId: requestBody.merchantId,
          Acquirer1: requestBody.acquirer,
          // selectedCurrency: "356",
          selectedCurrency: "784",
          loggedUserEmailId: this.systemAdmin,
          type: 3
        };
    
        console.log("Request payload for fetching paymentType:", requestPayload);
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/getData`, requestPayload);
      }
    
    
      getMopTypes(requestBody: { payId: string; acquirer: string; selectedCurrency: any; paytype: string }): Observable<any> {
        const requestPayload = {
          payId: requestBody.payId,
          Acquirer1: requestBody.acquirer,
          selectedCurrency: requestBody.selectedCurrency,
          paytype: requestBody.paytype,
          loggedUserEmailId: this.systemAdmin,
          type: 4
        };
    
        console.log("Request payload for fetching mop types:", requestPayload);
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/getData`, requestPayload);
      }
    
      saveOffusData(data: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/onusoffusRulesSetup`, data);
      }
  
      updateRules(data: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/editRouterRule`, data);
      }



    //************* SMART ROUTER **************

      getSmartRules(payload: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/smartRouter`, payload);
      }
      saveData(payload: any) {
        return this.apiHttpService.post(`${API_URLPG}crm-merchant-setup/editRouterConfiguration`, payload);
      }





      saveUpdateTxnSessionConfig(data: any) {
        return this.apiHttpService.post(`${API_URLPG}merchant-config/save`, data);
      }
    
      fetchTxnSessionConfigByPayId(payId: string) {
        return this.apiHttpService.get(`${API_URLPG}merchant-config/fetch?payId=${payId}`);
      }
    
      deleteTxnSessionConfigById(payId: string) {
        return this.apiHttpService.get(`${API_URLPG}merchant-config/delete?payId=${payId}`);
      }
    
      getAllTxnConfigSession() {
        return this.apiHttpService.get(`${API_URLPG}merchant-config/fetchAll`);
      }
    
    
      getAllAcquirerTypes() {
        return this.apiHttpService.get(`${API_URLPG}crm-dashboard/acquirer-types`);
      }
    
      sendSms(data: any) {
        //  const API_URLPGa= "https://preprod.pay10.com/"
        return this.apiHttpService.post(`${API_URLPG}crmws/merchant-wise-callback/fetch`, data);
      }
      
    
    



  // Method to retrieve merchant data based on payId
  getMerchantData(payId: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}SettlementProcess/getMerchantData/${payId}`);
  }

  // Method to update advance amount allocation
  updateAdvanceAmountAllocation(data: any): Observable<any> {
    return this.apiHttpService.post(`${API_URLPG}SettlementProcess/UpdateAdvanceAmountAllocationWithCommercial`, data);
  }

  // Method to save settlement settings
  saveSettlementSetting(data: any): Observable<any> {
    return this.apiHttpService.post(`${API_URLPG}SettlementProcess/SaveSettlementSetting`, data);
  }

  // Example method to retrieve payment type based on payId
  getPaymentType(payId: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}SettlementProcess/getPaymentType/${payId}`);
  }

  getMerchantDataWithPaymentbased(payId: string, paymentBasedSettlement: boolean, type: boolean): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}SettlementProcess/getMerchantDataWithPaymentbased/${payId}/${paymentBasedSettlement}/${type}`);
  }

  getMerchantDataWithoutPaymentbased(payId: any, paymentBasedSettlement: boolean, type: boolean): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}SettlementProcess/getMerchantDataWithoutPaymentbased/${payId}/${paymentBasedSettlement}/${type}`);
  }
  //Frm
  getCurrencyListTdr(merchantPayId: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}crm-merchant-billing/frm-currency-list`, { params: { merchantPayId } });
  }

  getFrmDetails(merchantPayId: string, selectedCurrencyCode: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}crm-merchant-billing/frm-details`, { params: { merchantPayId, selectedCurrencyCode } });
  }
  getPaymentTypesN(merchantPayId: string, selectedCurrencyCode: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}crm-merchant-billing/frm-details-paymentType`, { params: { merchantPayId, selectedCurrencyCode } });
  }
  setTicketLimit(merchantPayId: string, selectedCurrencyCode: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}crm-merchant-billing/frm-details-by-ticket`, { params: { merchantPayId, selectedCurrencyCode } });
  }


  getFrmDetailsByVolume(merchantPayId: string, selectedCurrencyCode: string, selectedPaymentType: string): Observable<any> {
    return this.apiHttpService.get(`${API_URLPG}crm-merchant-billing/frm-details-by-volume`, {
      params: { merchantPayId, selectedCurrencyCode, selectedPaymentType }
    });
  }


  saveFrmDetails(data: any): Observable<any> {
    return this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/frm-save`, data);
  }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}